import {defineStore} from 'pinia'
import DataSource from "devextreme/data/data_source";
import { ref} from "vue";
import {useGajiPeriodeListModel} from "@/stores/models/gaji-periode-list-model";

export const useGajiPeriodeListStore  = defineStore(
    'gajiPeriodeListStore',
    () => {
       
        const isLoading = ref(false);
        const dataSourceGajiPeriodeList = ref(
            new DataSource({
                requireTotalCount: true,
                store: useGajiPeriodeListModel().gajiPeriodeListCustomStore,
                filter: null,
            })
        );
       
        const loadData = async (filter = null) => {
            isLoading.value = true;
            try {
                dataSourceGajiPeriodeList.value.filter(filter);
                // Reload the DataSource with the new filter
                const result = await dataSourceGajiPeriodeList.value.load();
                return result;
            } catch (error) {
                console.error("Error loading data:", error);
                throw error;
            } finally {
                isLoading.value = false;
            }
        };

        const insertData = async (newItem) => {
            try {
                const result = await dataSourceGajiPeriodeList.value.store().insert(newItem);
                return result;
            } catch (error) {
                console.error("Error inserting data:", error);
                throw error;
            }
        };

        const updateData = async (updatedRows) => {
            
            const store = dataSourceGajiPeriodeList.value.store();
            try {
                // Create an array of update promises
                const updatePromises = updatedRows.map(row => {
                  return store.update(row.id, row); // Assume `id` is the key field
                });
          
                // Wait for all update operations to complete
               
                const results = await Promise.all(updatePromises);
          
                return results;
              } catch (error) {
                console.error("Error updating data:", error);
                throw error;
              }
        };


        



        const state = ref(true);
        const onMuatButtonClick =()=>{
            state.value = false;
            dataSourceGajiPeriodeList.value.reload();
        };

     

        const initialized = ()=>{     
            dataSourceGajiPeriodeList.value.reload();
        };

        return {
           loadData,
           insertData,
           updateData,
            dataSourceGajiPeriodeList,
            isLoading,
            onMuatButtonClick,
            initialized,
            state

        }
    }
);